import React from 'react';
import { HeaderMfe } from '|/app/header';
import SlateHeader from '|/app/header/slate-header';
import VehicleHeader from '|/app/header/purchase-header/treatment/vehicle-confirmation-header';
import { useSlate } from '|/context';
import { isCarvanaNativeApp } from '|/helpers/is-native-app';

const VehicleRouteHeader = () => {
  const { isSlateSkin } = useSlate();
  if (isSlateSkin) return <SlateHeader />;
  return isCarvanaNativeApp() ? <VehicleHeader /> : <HeaderMfe orderSummary={null} />;
};

export default VehicleRouteHeader;
